import apiClient from "./axiosInstance"

type GetQueryType = {
  start_date: string
  end_date: string
  page: number
  per_page: number
  is_active: boolean | null
  is_running: boolean | null
  signal?: AbortSignal
}
type UpdateQueryType = {
  is_running: boolean
  is_active: boolean
}
type CreeateQueryType = {
  gpu_count: number
  is_running: boolean
  is_active: boolean
  query: string
  frame_strategy: string
  interruptible:boolean
}

export const TAgetRunpodWorkers = async (query: GetQueryType) => {
  const params = new URLSearchParams(
    Object.entries(query)
      .filter(([_, v]) => v !== null && v !== undefined && v !== "")
      .reduce((acc, [k, v]) => ({ ...acc, [k]: String(v) }), {}),
  )

  const response = await apiClient.get(`/admin/runpod-workers/?${params.toString()}`, {
    signal: query.signal,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}

export const TAupdateRunpodWorkers = async (data: UpdateQueryType) => {
  const response = await apiClient.post("/admin/runpod-workers/update", {
    ...data,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}

export const TAcreateRunpodWorkers = async (data: CreeateQueryType) => {
  const response = await apiClient.post("/admin/runpod-workers/new/", {
    ...data,
  })

  if (response.status === 201) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}

export const TAstopRunpodWorkers = async (pod_id: string) => {
  const response = await apiClient.post("/admin/runpod-workers/stop-pod/", {
    pod_id,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}

export const TAgetRunpodWorkerPosts = async (post_ids: string[], signal?: AbortSignal) => {
  const response = await apiClient.get(
    `/admin/runpod-workers/posts/?post_ids=${post_ids.join(",")}`,
    {
      signal: signal,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data.message)
  }
}
